import { useState, useStore } from 'vuex-composition-helpers';
import registerModule from '@ve/services/registerModule';
import HotelOffersTariffsStore from '@ve/components/hotel/hotelOffersTariffsPopup/common/store/HotelOffersTariffsStore';

export default (storeModuleName = 'hotelOffersTariffsStore') => {
    const store = useStore();

    registerModule
        .register(store, HotelOffersTariffsStore, storeModuleName);

    const { tariffs } = useState(storeModuleName, ['tariffs']);

    return {
        tariffs,
    };
};